import Role from "~/types/Role";

export function canAssignUserRole(roleName: string, editorRoles: readonly string[]): boolean {
  return editorRoles.some(role =>
    role === Role.SUPER_ADMIN
    || (role === Role.ADMIN && roleName !== Role.SUPER_ADMIN)
    || (role === Role.MANAGER && ![Role.ADMIN, Role.SUPER_ADMIN].includes(roleName as Role))
    || (role === Role.MANAGER_PLACER && [Role.PLACER, Role.HEAD_OF_PLACERS].includes(roleName as Role)),
  );
}
